/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_SubInputs */

const en_mk_how_sub = /** @type {(inputs: Mk_How_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four steps, no installation required.`)
};

const id_mk_how_sub = /** @type {(inputs: Mk_How_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empat langkah, tanpa instalasi apa pun.`)
};

/**
* | output |
* | --- |
* | "Four steps, no installation required." |
*
* @param {Mk_How_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_sub = /** @type {((inputs?: Mk_How_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_sub(inputs)
	return en_mk_how_sub(inputs)
});